import { formatImageSideLabel } from '../utils'
import { normalizeBulkDeleteSideKey } from './csvUtils'

export function buildPreviewItemsFromRows(parsedRows) {
  return parsedRows.map((row) => ({
    sku: row.sku,
    imageSideCode: row.side,
    sideLabel: formatImageSideLabel(row.side),
  }))
}

/**
 * Preview table follows CSV row order and side values; API items are used only
 * when they match a CSV row.
 */
export function buildPreviewDisplayItems(apiItems, parsedRows) {
  const itemsFromCsv = buildPreviewItemsFromRows(parsedRows)

  if (!apiItems?.length) {
    return itemsFromCsv
  }

  const apiByKey = new Map()
  apiItems.forEach((item) => {
    const sku = String(item.sku ?? item.SKU ?? '').trim()
    const side =
      item.imageSideCode ??
      item.image_side_code ??
      item.side ??
      item.imageSide ??
      ''
    const key = `${sku}|${normalizeBulkDeleteSideKey(side)}`
    if (sku && side) {
      apiByKey.set(key, item)
    }
  })

  return itemsFromCsv.map((csvItem) => {
    const key = `${csvItem.sku}|${normalizeBulkDeleteSideKey(csvItem.imageSideCode)}`
    const apiItem = apiByKey.get(key)

    if (!apiItem) {
      return csvItem
    }

    return {
      sku: csvItem.sku,
      imageSideCode: csvItem.imageSideCode,
      sideLabel: formatImageSideLabel(csvItem.imageSideCode),
    }
  })
}
